import d3Legacy from 'd3-legacy';
import _each from 'lodash/each';
import _toInteger from 'lodash/toInteger';
import moment from 'moment';
import _floor from 'lodash/floor';
import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
import clearNodeChildren from 'js/helpers/clearNodeChildren';
import * as deviceInformation from 'js/helpers/device';
import { plot_config } from './config';
export function formatXAxisDate(d) {
  var date = new Date();
  date.setMonth(d - 1);
  return getCurrentD3Locale().timeFormat(deviceInformation.isMobileWidth() ? '%m' : '%b')(date);
}
export function renderBarGraph(props, category, categoryTitle, countryID, plotID) {
  var data = props.data;
  var json = data[category];
  var values = json.values;
  var date1 = new Date();
  var date2 = new Date();
  date1.setFullYear(json.year, 0, 1);
  date2.setFullYear(json.year, 11, 31); // Sets margins of plot

  var margin = {
    top: 20,
    right: 0,
    bottom: 30,
    left: 30
  };

  var graphWidth = _floor(document.getElementById("".concat(plotID, "_graph")).offsetWidth);

  var width = _floor(graphWidth / 2) - margin.left - margin.right;
  var height = 400 - margin.top - margin.bottom; // Defines variables x and y, which are used by d3 to map values to pixels

  var x = d3Legacy.scale.ordinal().rangeRoundBands([0, width], 0.1);
  var y = d3Legacy.scale.linear().range([height, 0]);
  var xAxis = d3Legacy.svg.axis().scale(x).tickFormat(formatXAxisDate).orient('bottom');
  var yAxis = d3Legacy.svg.axis().scale(y).orient('left');
  var svgWrapperId = "".concat(plotID, "-svg-wrapper-").concat(category);
  var $svgWrapper = $(["<div class=\"".concat(plotID, "__svg-wrapper\" style=\"width:").concat(width + margin.left + margin.right, "px;"), "height:".concat(height + margin.top + margin.bottom, "px;"), '" id="', svgWrapperId, '">', "<div class=\"".concat(plotID, "__title\">"), categoryTitle, '</div></div>'].join(''));
  $("#".concat(plotID, "_graph")).append($svgWrapper);
  var svg = d3Legacy.select("#".concat(svgWrapperId)).append('svg').attr('class', 'cosmos-svg--with-overflow').attr('width', '100%').attr('height', '100%').append('g').attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")")); // Get max y value between datasets
  // That way, the y axis will be scaled to the largest of the two datasets.

  var generationMax = d3Legacy.max(values, function (d) {
    return d.currentMonthly;
  });
  var generationPrevYearMax = d3Legacy.max(values, function (d) {
    return d.prevYearMonthly;
  });
  var generationHistMax = d3Legacy.max(values, function (d) {
    return d.historicalMonthly;
  });
  x.domain(values.map(function (d) {
    return d.month;
  }));
  y.domain([0, Math.max(generationMax, generationPrevYearMax, generationHistMax)]);
  svg.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(height, ")")).call(xAxis);
  svg.append('g').attr('class', 'cosmos-axis cosmos-axis--y').call(yAxis).append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', plot_config.Y_AXIS_LABEL_X).attr('y', plot_config.Y_AXIS_LABEL_Y).text(plot_config.Y_AXIS_LABEL);
  var barWidth = x.rangeBand() / 3;
  var barMargin = barWidth / 2;
  var barHoverGreyBackgroundRect = svg.append('rect').attr('class', "".concat(plotID, "-graph__grey-background-bar")).attr('width', x.rangeBand()).attr('height', height).attr('y', height - y(0)).attr('display', 'none'); // Adding the bars

  _each([{
    class: 'blueLine',
    key: function key(d) {
      return d.historicalMonthly;
    }
  }, {
    class: 'greenLine',
    key: function key(d) {
      return d.prevYearMonthly;
    }
  }, {
    class: 'orangeLine',
    key: function key(d) {
      return d.currentMonthly;
    }
  }], function (bar, index) {
    svg.selectAll(".".concat(bar.class)).data(values).enter().append('rect').attr('rx', 3).attr('ry', 3).attr('class', bar.class).attr('x', function (d) {
      return x(d.month) + barMargin * (index + 1);
    }).attr('width', barWidth).attr('y', function (d) {
      return y(bar.key(d));
    }).attr('height', function (d) {
      return height - y(bar.key(d));
    }).on('mouseover', onBarMouseOver).on('mouseout', onBarMouseOut);
  });

  var tooltipNodes = {};

  _each(plot_config.TOOLTIP_KEYS, function (tooltipKey) {
    tooltipNodes[tooltipKey] = {
      node: svg.append('g').attr('class', 'cosmos-focus-node').attr('display', 'none')
    };
    tooltipNodes[tooltipKey].rect = tooltipNodes[tooltipKey].node.append('rect').attr('rx', '5px').attr('ry', '5px').attr('class', 'cosmos-focus-node__tooltip');
    tooltipNodes[tooltipKey].text = tooltipNodes[tooltipKey].node.append('text').attr('class', 'cosmos-focus-node__tooltip-text');
  });

  function onBarMouseOver(d) {
    var nodePositionX = x(d.month);
    var nodePositionY = margin.top;
    barHoverGreyBackgroundRect.attr('x', nodePositionX).attr('display', null);

    _each(plot_config.TOOLTIP_KEYS, function (tooltipKey, tooltipKeyIndex) {
      var tooltipNode = tooltipNodes[tooltipKey].node;
      var tooltipNodeText = tooltipNodes[tooltipKey].text;
      var tooltipNodeRect = tooltipNodes[tooltipKey].rect;
      tooltipNode.attr('display', null);
      tooltipNodeText.style('text-anchor', 'start').attr('x', plot_config.TOOLTIP_X_MARGIN + x.rangeBand()).attr('y', plot_config.TOOLTIP_Y_MARGIN).text([plot_config.BAR_TOOLTIP_TEXT_MAP[tooltipKey], _toInteger(d[tooltipKey]), plot_config.Y_AXIS_LABEL].join(' '));
      var textBBox = tooltipNodeText[0][0].getBBox();

      if (nodePositionX >= width / 2) {
        tooltipNodeText.style('text-anchor', 'end').attr('x', -plot_config.TOOLTIP_X_MARGIN);
        textBBox = tooltipNodeText[0][0].getBBox();
      }

      tooltipNodeRect.attr('stroke', plot_config.BAR_COLOR_MAP[tooltipKey]).attr('width', textBBox.width + plot_config.TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + plot_config.TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - plot_config.TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - plot_config.TOOLTIP_TOP_BOTTOM_PADDING);
      tooltipNode.attr('transform', "translate(".concat(nodePositionX, ",").concat(nodePositionY + tooltipKeyIndex * (tooltipNodeRect[0][0].getBBox().height + plot_config.TOOLTIP_Y_MARGIN), ")"));
    });
  }

  function onBarMouseOut() {
    barHoverGreyBackgroundRect.attr('display', 'none');

    _each(plot_config.TOOLTIP_KEYS, function (tooltipKey) {
      tooltipNodes[tooltipKey].node.attr('display', 'none');
    });
  }

  return [moment(date1), moment(date2)];
}
export function initializePlot(props) {
  var countryID = props.countryID,
      plotID = props.plotID;
  if (!document.getElementById("".concat(plotID, "_graph"))) return;
  clearNodeChildren(document.getElementById("".concat(plotID, "_graph")));
  renderBarGraph(props, 'hydro', 'Hydro Generation', countryID, plotID);
  props.actions.setTotalDateRange(countryID, plotID, renderBarGraph(props, 'biomass', 'Biomass Generation', countryID, plotID));
}